import { StyledProps, React, withStyles, _, Fragment } from '@api';
import { MenuItem, ListItemText, Checkbox, ClickAwayListener, Popper, Paper, Grow } from '@material-ui/core'
import { TertiaryButton } from './'
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons'

const styles = () => ({
  headlineLabel:   {
    fontSize:   14,
    whiteSpace: 'nowrap',
    marginLeft: 5,
    color:      'rgba(27, 27, 27, 0.54)'
  },
  headline:        {
    fontSize:   14,
    whiteSpace: 'nowrap',
    marginLeft: 5,
    cursor:     'pointer',
    color:      'rgba(27, 27, 27, 0.54)'
  },
  headlineLibrary: {
    fontSize:   14,
    whiteSpace: 'nowrap',
    marginLeft: 5,
    cursor:     'pointer',
    color:      'rgba(27, 27, 27, 0.54)',
    height:     '48px',
    lineHeight: '48px'
  },
  arrow:           {
    cursor: 'pointer'
  },
  checkbox:        {
    width:       20,
    height:      20,
    marginRight: 10,
    '& svg':     {
      width:  20,
      height: 20
    }
  },
  menuRoot:        {
    padding: '12px 0px 12px 16px'
  },
  listItemText:    {
    width:         126,
    height:        20,
    fontSize:      14,
    lineHeight:    1.43,
    letterSpacing: 0.2,
    color:         'rgba(27, 27, 27, 0.87)'
  },
  paper:           {
    borderRadius: 0
  },
  buttonLabel:     {
    textTransform: 'capitalize'
  }
})

interface MyProps extends StyledProps {
  label?: string,
  displayValue: string,
  options?: Array<{value, name}>,
  onChange?: (e) => void,
  value?: any,
  multiple?: boolean
  disablePortal?: boolean
}

export class SelectFieldComponent extends React.Component<MyProps, {anchorEl?: HTMLAnchorElement}> {
  static defaultProps = {
    multiple:      false,
    disablePortal: true
  }

  state = {
    anchorEl: undefined
  }
  onClickSelect = (e) => {
    this.setState({
      anchorEl: e.target
    })
  }

  handleClose = () => {
    this.setState({
      anchorEl: undefined
    })
  }

  onChangeSelect = (e, value) => {
    if (this.props.onChange) {
      this.props.onChange(value)
    }
    if (!this.props.multiple) {
      this.handleClose()
    }
  }

  render() {
    const {label, classes, displayValue, options, value, multiple, disablePortal} = this.props
    return (<Fragment>
      <TertiaryButton classes={{buttonLabel: classes.buttonLabel}}
                      icon={{position: 'right', component: this.state.anchorEl ? <ArrowDropUp className={classes.arrow}/> : <ArrowDropDown className={classes.arrow}/>}}
                      onClick={this.onClickSelect}>
        {`${label}${label ? ':' : ''} ${displayValue}`}
      </TertiaryButton>
      <Popper open={Boolean(this.state.anchorEl)} anchorEl={this.state.anchorEl} placement={'bottom'} transition disablePortal>
        {({TransitionProps, placement}) => (
          <Grow
            {...TransitionProps}
            // id='menu-list-grow'
            style={{transformOrigin: 'bottom'}}
          >
            <Paper classes={{root: classes.paper}}>
              <ClickAwayListener onClickAway={this.handleClose}>
                {_.map(options, (option, i) => {
                  return (
                    <MenuItem
                      key={`${option.value}_${label}_${i}`}
                      classes={{root: classes.menuRoot}}
                      onClick={(e) => { this.onChangeSelect(e, option.value) }}>
                      <ListItemText primary={option.name} classes={{primary: classes.listItemText}}/>
                      {multiple && <Checkbox classes={{root: classes.checkbox}} checked={value[option.value]}/>}
                    </MenuItem>
                  )
                })}
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Fragment>)
  }
}

@(withStyles as any)(styles)
export class SelectField extends SelectFieldComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/SelectField.tsx